<template>
  <MglMarker :coordinates="markerCoordinates" :offset="[0, -20]">
    <i slot="marker" :class="{ 'modified-z-index': foreground }">
      <slot />
    </i>
  </MglMarker>
</template>

<script>
import { MglMarker } from 'vue-mapbox'

export default {
  components: {
    MglMarker,
  },
  props: {
    coordinates: {
      type: Object,
      required: true,
    },
    foreground: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    markerCoordinates () {
      return [this.coordinates.lng, this.coordinates.lat]
    },
  }
}
</script>

<style lang="scss" scoped>
.modified-z-index {
  z-index: 1;
}
</style>
